export const subheaderStyles = {
  padding: '12px 16px 8px',
  borderTop: ({ palette }) => `1px solid ${palette.border.default}`,
};
